/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var CheckCircleFillIcon = function CheckCircleFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM8.70711 10.9498L10.8284 13.0711L15.7782 8.12137L17.1924 9.53559L10.8284 15.8995L7.29289 12.364L8.70711 10.9498Z"
  }));
};
export default CheckCircleFillIcon;